<template>
  <el-dialog
    custom-class="workerorder-detail"
    :visible.sync="dialogShow"
    width="1000px"
    append-to-body
    :close-on-click-modal="false"
    :modal-append-to-body="false"
  >
    <template slot="title">
      <div class="flex align-items-center">
        <span class="font-20">结算明细</span>
        <f-date-range-picker
          class="ml"
          v-model="query.time"
          @change="fetchData"
          :picker-options="pickerOptions"
        />
        <div class="filter-item ml-sm">
          <sys-user-selector
            v-model="query.uid"
            @change="fetchData"
            :multiple="false"
            placeholder="全部成员"
          ></sys-user-selector>
        </div>
      </div>
    </template>
    <div class="table-c">
      <el-table ref="listTable" :data="list" height="500" class="padding-small" v-loading="loading">
        <el-table-column type="index" width="60" label="#"></el-table-column>
        <el-table-column label="结算时间" width="170">
          <template slot-scope="scope">
            <span>{{ scope.row.confirm_time | parseTime }}</span>
          </template>
        </el-table-column>

        <el-table-column label="姓名" min-width="100">
          <template slot-scope="scope">
            <f-user-avatar :user="scope.row"></f-user-avatar>
            <f-user-name class="ml-sm" :user="scope.row"></f-user-name>
          </template>
        </el-table-column>

        <el-table-column label="工时" min-width="100">
          <template slot-scope="scope">
            <span>
              +
              <span class="number text-bold">{{scope.row.confirm_hour }}</span>
              <span>{{" " + scope.row.standard_unit }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{
            scope.row.status == 1 ? "已结单" : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="关联工单" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="flex">
              <span class="text-muted order-no">{{ scope.row.workorder_no }}</span>
              <icon-svg v-if="scope.row.type == 1" icon-class="maintask" style="font-size: 22px" />
              <icon-svg v-if="scope.row.type == 2" icon-class="subtask" style="font-size: 22px" />
            </div>
            <br />
            <el-link
              :underline="false"
              class="ellipsis"
              @click="toDetail(scope.row.workorderid)"
            >{{ scope.row.workorder_title }}</el-link>
          </template>
        </el-table-column>

        <template slot="empty">
          <img class="image huger mt-lg" src="@/assets/empty.png" />
          <div class="font-md mb-hg">暂无数据</div>
        </template>
      </el-table>
      <f-table-footer
        :checkbox="false"
        :list="list"
        :total="total"
        :pindex.sync="query.pindex"
        :psize.sync="query.psize"
        :selection="[]"
        @change="fetchData"
        showExport
      >
        <template slot="left">
          <el-button plain size="mini" @click="exportD">导出</el-button>
        </template>
      </f-table-footer>
    </div>
  </el-dialog>
</template>

<script>
import { kpiDLApi, exportDetailApi } from "@/api/kpi/kpiApi.js";
// import { getAllRole } from '@/api/sys/roleApi'
import moment from "moment";
export default {
  name: "WorkorderDetail",
  components: {
    SysUserSelector: () => import("@/views/sys/components/SysUserSelector.vue")
  },
  props: {
    uid: {
      type: Number
    },
    show: {
      type: Boolean,
      default: false
    },
    inittime: {
      type: [Number, String]
    }
  },
  data() {
    return {
      list: [],
      query: {
        uid: 0,
        time: [],
        pindex: 1,
        psize: 10
      },
      total: 0,
      // roleList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      }
    }
  },
  created() {
    this.query.uid = this.uid;

    this.query.time = [
      moment(this.inittime)
        .startOf("month")
        .unix(),
      moment(this.inittime)
        .endOf("month")
        .unix()
    ];

    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;
      kpiDLApi(this.query).then(res => {
        if (!res.errno) {
          this.list = res.data.list;
          this.total = res.data.total;
          this.query.pindex = res.data.pindex;
          this.query.psize = res.data.psize;
        } else {
          this.$message.error(res.message);
        }
        this.loading = false;
      });
    },

    exportD() {
      exportDetailApi(this.query).then(res => {
        if (!res.errno) {
          window.open(res.data.url);
          this.$message.success("导出成功！");
        }
      });
    },

    toDetail(id) {
      this.$detail(id);
    }
  }
};
</script>

<style lang="scss" scoped>
.workerorder-detail {
  .el-dialog__body {
    padding-top: 0;
  }
}

.el-dialog__body {
  padding-top: 0;
}

.f-table-footer {
  position: relative;
  // bottom: 0px;
  left: 0px;
  padding: 16px 0px 16px 20px;
  box-shadow: none;
  border-radius: 0px;
}
</style>
